import { useEffect, useId, useRef, useState } from 'react';
import AssetView from './AssetView';
import SubmittedData from './SubmittedData';
import style from './AssetViewWithTracking.module.css';

const TrackedAssetView = ({ styleName, url, title }) => {
  const iframeRef = useRef(null);
  const headingId = useId();
  const [submittedData, setSubmittedData] = useState(null);

  useEffect(() => {
    const receiveTrackingData = (event) => {
      // Only the currently displayed asset can populate the tracking panel.
      if (!iframeRef.current || event.source !== iframeRef.current.contentWindow) return;
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (data === null || typeof data !== 'object') return;
        const json = JSON.stringify(data);
        if (json !== undefined) setSubmittedData(JSON.parse(json));
      } catch {
        // Ignore messages that do not contain serializable JSON data.
      }
    };
    window.addEventListener('message', receiveTrackingData);
    return () => window.removeEventListener('message', receiveTrackingData);
  }, []);

  return (
    <div className={`${style.preview} ${submittedData !== null ? style.withTracking : ''}`}>
      <AssetView iframeRef={iframeRef} styleName={styleName} url={url} title={title} />
      {submittedData !== null && (
        <aside className={style.tracking} aria-labelledby={headingId}>
          <h2 id={headingId}>Submitted data</h2>
          <p className={style.trackingDescription}>Details from the latest submission</p>
          <SubmittedData data={submittedData} />
        </aside>
      )}
    </div>
  );
};

// A different asset starts a fresh iframe and submission history.
const AssetViewWithTracking = (props) => (
  <TrackedAssetView key={JSON.stringify([props.url, props.title])} {...props} />
);

export default AssetViewWithTracking;
